import backend from '@common/backend';

const BASE = '/steps';

export const postStep = async (data: any) => backend.post(`${BASE}`, data);

export const saveStep = async (id: number, data: any) => backend
	.patch(`${BASE}/${id}`, data);

export const deleteStep = async (id: number) => backend.delete(`${BASE}/${id}`);

export const postSteps = async (data: any) => backend.post(`${BASE}/bulk/create`, data);

export const saveSteps = async (data: any) => backend.put(`${BASE}/bulk/update`, data);

export const deleteSteps = async (data: any) => backend.delete(`${BASE}/bulk/delete`, data);
